var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocuments = function SvgDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "gray",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.59 5.721-1.495 6.532a4.82 4.82 0 0 0 3.623 5.773l3.928.9a4.82 4.82 0 0 0 5.774-3.624l1.495-6.531a4.82 4.82 0 0 0-3.624-5.774l-3.928-.899a4.82 4.82 0 0 0-5.774 3.623",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.64 18.92 10.72 18a4.83 4.83 0 0 1-3.63-5.78l1.5-6.53A4.4 4.4 0 0 1 9 4.7l-3.54 1a4.77 4.77 0 0 0-3.26 5.91l1.73 6a4.78 4.78 0 0 0 5.87 3.31l4.13-1.19c.513-.163.997-.41 1.43-.73a4.5 4.5 0 0 1-.72-.08M17.4 10.41a.7.7 0 0 1-.19 0l-4.7-1.2a.753.753 0 0 1 .37-1.46l4.71 1.21a.75.75 0 0 1-.19 1.47z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.49 13.82h-.19l-2.78-.72a.753.753 0 0 1 .37-1.46l2.79.73a.75.75 0 0 1 .54.91.77.77 0 0 1-.73.54"
  })));
};
export default SvgDocuments;